var _excluded = ["analyticsName", "title", "children", "startExpanded", "justifyContent", "noPadding", "wrapText", "expandOnFocus", "panelId", "onOpen", "onToggle", "variant", "onMouseEnter", "maxHeight", "hasUnderline", "hasBorder", "paddingInline"],
    _excluded2 = ["isOpen", "panelId"],
    _excluded3 = ["panelId", "isOpen", "maxHeight", "onContentFocus"];

function cov_22w7c5ye2p() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx";
  var hash = "7e3835284831e84b162c3dd7fa2776f1dd318115";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 33,
          column: 67
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "1": {
        start: {
          line: 65,
          column: 32
        },
        end: {
          line: 65,
          column: 64
        }
      },
      "2": {
        start: {
          line: 66,
          column: 31
        },
        end: {
          line: 66,
          column: 53
        }
      },
      "3": {
        start: {
          line: 67,
          column: 19
        },
        end: {
          line: 78,
          column: 6
        }
      },
      "4": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 95,
          column: 58
        }
      },
      "5": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 87,
          column: 7
        }
      },
      "6": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 17
        }
      },
      "7": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 29
        }
      },
      "8": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 92,
          column: 11
        }
      },
      "9": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 45
        }
      },
      "10": {
        start: {
          line: 93,
          column: 32
        },
        end: {
          line: 93,
          column: 43
        }
      },
      "11": {
        start: {
          line: 97,
          column: 24
        },
        end: {
          line: 107,
          column: 5
        }
      },
      "12": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 99,
          column: 40
        }
      },
      "13": {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 103,
          column: 13
        }
      },
      "14": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 136,
          column: 6
        }
      },
      "15": {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 126,
          column: 56
        }
      },
      "16": {
        start: {
          line: 148,
          column: 63
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "17": {
        start: {
          line: 149,
          column: 17
        },
        end: {
          line: 149,
          column: 64
        }
      },
      "18": {
        start: {
          line: 150,
          column: 2
        },
        end: {
          line: 166,
          column: 4
        }
      },
      "19": {
        start: {
          line: 170,
          column: 71
        },
        end: {
          line: 178,
          column: 1
        }
      },
      "20": {
        start: {
          line: 171,
          column: 17
        },
        end: {
          line: 171,
          column: 64
        }
      },
      "21": {
        start: {
          line: 173,
          column: 2
        },
        end: {
          line: 177,
          column: 4
        }
      },
      "22": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "23": {
        start: {
          line: 184,
          column: 17
        },
        end: {
          line: 187,
          column: 4
        }
      },
      "24": {
        start: {
          line: 188,
          column: 2
        },
        end: {
          line: 198,
          column: 4
        }
      },
      "25": {
        start: {
          line: 195,
          column: 21
        },
        end: {
          line: 195,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 64,
            column: 7
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 64
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 84,
            column: 36
          },
          end: {
            line: 84,
            column: 37
          }
        },
        loc: {
          start: {
            line: 84,
            column: 42
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 84
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 93,
            column: 17
          }
        },
        loc: {
          start: {
            line: 93,
            column: 32
          },
          end: {
            line: 93,
            column: 43
          }
        },
        line: 93
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        },
        loc: {
          start: {
            line: 98,
            column: 13
          },
          end: {
            line: 104,
            column: 7
          }
        },
        line: 98
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 125,
            column: 26
          },
          end: {
            line: 125,
            column: 27
          }
        },
        loc: {
          start: {
            line: 125,
            column: 47
          },
          end: {
            line: 127,
            column: 11
          }
        },
        line: 125
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 148,
            column: 63
          },
          end: {
            line: 148,
            column: 64
          }
        },
        loc: {
          start: {
            line: 148,
            column: 98
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 148
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 170,
            column: 71
          },
          end: {
            line: 170,
            column: 72
          }
        },
        loc: {
          start: {
            line: 170,
            column: 82
          },
          end: {
            line: 178,
            column: 1
          }
        },
        line: 170
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        loc: {
          start: {
            line: 183,
            column: 66
          },
          end: {
            line: 199,
            column: 1
          }
        },
        line: 183
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 195,
            column: 15
          },
          end: {
            line: 195,
            column: 16
          }
        },
        loc: {
          start: {
            line: 195,
            column: 21
          },
          end: {
            line: 195,
            column: 61
          }
        },
        line: 195
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 42,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 27
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 44,
            column: 18
          },
          end: {
            line: 44,
            column: 23
          }
        }],
        line: 44
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 21
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 46,
            column: 22
          },
          end: {
            line: 46,
            column: 27
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 27
          },
          end: {
            line: 69,
            column: 28
          }
        }, {
          start: {
            line: 69,
            column: 31
          },
          end: {
            line: 69,
            column: 32
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 73,
            column: 18
          },
          end: {
            line: 73,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 29
          },
          end: {
            line: 73,
            column: 37
          }
        }, {
          start: {
            line: 73,
            column: 40
          },
          end: {
            line: 73,
            column: 48
          }
        }],
        line: 73
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 16
          }
        }, {
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 27
          }
        }],
        line: 85
      },
      "8": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 14
          }
        }, {
          start: {
            line: 88,
            column: 18
          },
          end: {
            line: 88,
            column: 28
          }
        }],
        line: 88
      },
      "9": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 92,
            column: 10
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 19
          }
        }, {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 10
          }
        }],
        line: 89
      },
      "10": {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 99,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 99,
            column: 20
          }
        }, {
          start: {
            line: 99,
            column: 24
          },
          end: {
            line: 99,
            column: 39
          }
        }],
        line: 99
      },
      "11": {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 103,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 21
          }
        }, {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 103,
            column: 12
          }
        }],
        line: 100
      },
      "12": {
        loc: {
          start: {
            line: 118,
            column: 11
          },
          end: {
            line: 118,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 39
          },
          end: {
            line: 118,
            column: 80
          }
        }, {
          start: {
            line: 118,
            column: 83
          },
          end: {
            line: 118,
            column: 88
          }
        }],
        line: 118
      },
      "13": {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 25
          }
        }, {
          start: {
            line: 126,
            column: 29
          },
          end: {
            line: 126,
            column: 36
          }
        }, {
          start: {
            line: 126,
            column: 40
          },
          end: {
            line: 126,
            column: 55
          }
        }],
        line: 126
      },
      "14": {
        loc: {
          start: {
            line: 129,
            column: 11
          },
          end: {
            line: 133,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 130,
            column: 12
          },
          end: {
            line: 130,
            column: 59
          }
        }, {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 20
          }
        }],
        line: 129
      },
      "15": {
        loc: {
          start: {
            line: 195,
            column: 21
          },
          end: {
            line: 195,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 21
          },
          end: {
            line: 195,
            column: 35
          }
        }, {
          start: {
            line: 195,
            column: 39
          },
          end: {
            line: 195,
            column: 61
          }
        }],
        line: 195
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e3835284831e84b162c3dd7fa2776f1dd318115"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22w7c5ye2p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_22w7c5ye2p();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState } from 'react';
import { Box, Button, Flex, Text, ListItem } from '..';
import Icon from '../Icon/Icon';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { useMultiStyleConfig } from '../../system/utils';
import { forwardRef } from '@chakra-ui/system';

/** Accordion component that has the ability to open for additional info or close for less info. This component is used by AccordionList which stacks several Accordions together */
export var AccordionListItem = (cov_22w7c5ye2p().s[0]++, forwardRef(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
      title = _ref.title,
      children = _ref.children,
      _ref$startExpanded = _ref.startExpanded,
      startExpanded = _ref$startExpanded === void 0 ? (cov_22w7c5ye2p().b[0][0]++, false) : _ref$startExpanded,
      justifyContent = _ref.justifyContent,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? (cov_22w7c5ye2p().b[1][0]++, false) : _ref$noPadding,
      _ref$wrapText = _ref.wrapText,
      wrapText = _ref$wrapText === void 0 ? (cov_22w7c5ye2p().b[2][0]++, true) : _ref$wrapText,
      _ref$expandOnFocus = _ref.expandOnFocus,
      expandOnFocus = _ref$expandOnFocus === void 0 ? (cov_22w7c5ye2p().b[3][0]++, false) : _ref$expandOnFocus,
      panelId = _ref.panelId,
      onOpen = _ref.onOpen,
      onToggle = _ref.onToggle,
      variant = _ref.variant,
      onMouseEnter = _ref.onMouseEnter,
      maxHeight = _ref.maxHeight,
      hasUnderline = _ref.hasUnderline,
      hasBorder = _ref.hasBorder,
      paddingInline = _ref.paddingInline,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_22w7c5ye2p().f[0]++;

  var _ref2 = (cov_22w7c5ye2p().s[1]++, useState(startExpanded)),
      _ref3 = _slicedToArray(_ref2, 2),
      isOpen = _ref3[0],
      setIsOpen = _ref3[1];

  var _ref4 = (cov_22w7c5ye2p().s[2]++, useObservabilitySafe()),
      trackUserEvent = _ref4.trackUserEvent;

  var styles = (cov_22w7c5ye2p().s[3]++, useMultiStyleConfig('AccordionListItem', _objectSpread({
    variant: variant,
    padding: noPadding ? (cov_22w7c5ye2p().b[4][0]++, 0) : (cov_22w7c5ye2p().b[4][1]++, 7),
    paddingInline: paddingInline,
    justifyContent: justifyContent,
    isOpen: isOpen,
    whiteSpace: wrapText ? (cov_22w7c5ye2p().b[5][0]++, 'normal') : (cov_22w7c5ye2p().b[5][1]++, 'nowrap'),
    maxHeight: maxHeight,
    hasBorder: hasBorder,
    hasUnderline: hasUnderline
  }, props)));
  /**
   * Handles opening the accordion when button is clicked
   * Calls the onOpen callback (if provided) when we're opening the accordion
   * Calls the onToggle callback (if provided) when we're opening and closing the accordion
   */

  var handleClick = (cov_22w7c5ye2p().s[4]++, useCallback(function () {
    cov_22w7c5ye2p().f[1]++;
    cov_22w7c5ye2p().s[5]++;

    if ((cov_22w7c5ye2p().b[7][0]++, onOpen) && (cov_22w7c5ye2p().b[7][1]++, !isOpen)) {
      cov_22w7c5ye2p().b[6][0]++;
      cov_22w7c5ye2p().s[6]++;
      onOpen();
    } else {
      cov_22w7c5ye2p().b[6][1]++;
    }

    cov_22w7c5ye2p().s[7]++;
    (cov_22w7c5ye2p().b[8][0]++, onToggle) && (cov_22w7c5ye2p().b[8][1]++, onToggle());
    cov_22w7c5ye2p().s[8]++;
    (cov_22w7c5ye2p().b[9][0]++, analyticsName) && (cov_22w7c5ye2p().b[9][1]++, trackUserEvent({
      accordionClickEvent: {
        targetName: analyticsName,
        accordionName: panelId
      }
    }));
    cov_22w7c5ye2p().s[9]++;
    setIsOpen(function (prevIsOpen) {
      cov_22w7c5ye2p().f[2]++;
      cov_22w7c5ye2p().s[10]++;
      return !prevIsOpen;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onOpen, isOpen, onToggle, analyticsName, panelId]));
  var handleHover = (cov_22w7c5ye2p().s[11]++, useCallback(function (e) {
    cov_22w7c5ye2p().f[3]++;
    cov_22w7c5ye2p().s[12]++;
    (cov_22w7c5ye2p().b[10][0]++, onMouseEnter) && (cov_22w7c5ye2p().b[10][1]++, onMouseEnter(e));
    cov_22w7c5ye2p().s[13]++;
    (cov_22w7c5ye2p().b[11][0]++, analyticsName) && (cov_22w7c5ye2p().b[11][1]++, trackUserEvent({
      accordionHoverEvent: {
        targetName: analyticsName,
        accordionName: panelId
      }
    }));
  }, //eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName, panelId]));
  cov_22w7c5ye2p().s[14]++;
  return /*#__PURE__*/React.createElement(ListItem, {
    __css: styles.listItem,
    "data-testid": "accordion-list-item",
    ref: ref
  }, /*#__PURE__*/React.createElement(AccordionButton, {
    isOpen: isOpen,
    panelId: panelId,
    justifyContent: justifyContent,
    onClick: handleClick,
    onMouseEnter: handleHover
  }, typeof title === 'string' ? (cov_22w7c5ye2p().b[12][0]++, /*#__PURE__*/React.createElement(Text, {
    __css: styles.title
  }, title)) : (cov_22w7c5ye2p().b[12][1]++, title), /*#__PURE__*/React.createElement(AccordionIcon, {
    isOpen: isOpen,
    justifyContent: justifyContent
  })), /*#__PURE__*/React.createElement(AccordionPanel, {
    isOpen: isOpen,
    panelId: panelId,
    maxHeight: maxHeight,
    onContentFocus: function onContentFocus(isOpen) {
      cov_22w7c5ye2p().f[4]++;
      cov_22w7c5ye2p().s[15]++;
      (cov_22w7c5ye2p().b[13][0]++, expandOnFocus) && (cov_22w7c5ye2p().b[13][1]++, !isOpen) && (cov_22w7c5ye2p().b[13][2]++, setIsOpen(true));
    }
  }, typeof children === 'string' ? (cov_22w7c5ye2p().b[14][0]++, /*#__PURE__*/React.createElement(Text, {
    __css: styles.bodyText
  }, children)) : (cov_22w7c5ye2p().b[14][1]++, children)));
}));
cov_22w7c5ye2p().s[16]++;

/** Accordion button that handles if the accordion is open or close */
export var AccordionButton = function AccordionButton(_ref5) {
  var isOpen = _ref5.isOpen,
      panelId = _ref5.panelId,
      props = _objectWithoutProperties(_ref5, _excluded2);

  cov_22w7c5ye2p().f[5]++;
  var styles = (cov_22w7c5ye2p().s[17]++, useMultiStyleConfig('AccordionListItem', props));
  cov_22w7c5ye2p().s[18]++;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "ghost",
    __css: styles.button,
    "data-testid": "".concat(panelId, "-accordion-button") // We already track accordion hover/click events so we do not need duplicative tracking through Button
    ,
    analyticsName: "" // Blank aria-label because the question should be descriptive enough
    ,
    "aria-label": null // accordion controls value is equal the ID of the tag that wraps the expanded content
    ,
    "aria-controls": panelId // set on an element to indicate if a control is expanded or collapsed
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
    ,
    "aria-expanded": isOpen
  }, props));
};
/** Chevron icon used inside Accordion Button that users can click to open or close accordion */

cov_22w7c5ye2p().s[19]++;
export var AccordionIcon = function AccordionIcon(props) {
  cov_22w7c5ye2p().f[6]++;
  var styles = (cov_22w7c5ye2p().s[20]++, useMultiStyleConfig('AccordionListItem', props));
  cov_22w7c5ye2p().s[21]++;
  return /*#__PURE__*/React.createElement(Flex, {
    __css: styles.iconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-down",
    color: "neutrals100",
    size: 16
  }));
};
/** TODO: Panel is visable when isOpen is true */

cov_22w7c5ye2p().s[22]++;
export var AccordionPanel = function AccordionPanel(_ref6) {
  var panelId = _ref6.panelId,
      isOpen = _ref6.isOpen,
      maxHeight = _ref6.maxHeight,
      onContentFocus = _ref6.onContentFocus,
      props = _objectWithoutProperties(_ref6, _excluded3);

  cov_22w7c5ye2p().f[7]++;
  var styles = (cov_22w7c5ye2p().s[23]++, useMultiStyleConfig('AccordionListItem', {
    isOpen: isOpen,
    maxHeight: maxHeight
  }));
  cov_22w7c5ye2p().s[24]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    __css: styles.panel,
    "data-testid": "accordion-panel" // Hide from screen-readers while closed
    ,
    "aria-hidden": !isOpen,
    id: panelId,
    onFocus: function onFocus() {
      cov_22w7c5ye2p().f[8]++;
      cov_22w7c5ye2p().s[25]++;
      return (cov_22w7c5ye2p().b[15][0]++, onContentFocus) && (cov_22w7c5ye2p().b[15][1]++, onContentFocus(isOpen));
    }
  }, props));
};